/**
 * 通达信内置浏览器联动工具
 */

/**
 * 触发通达信联动跳转
 * @param {string} symbolCode 股票代码，格式如 "002222.SZ" 或 "601869.SH"
 */
export function tdxLinkStock(symbolCode) {
    if (!symbolCode) return;
    
    try {
        // 增强版检测：UA 包含 Tdx 或者存在外部对象
        // 很多通达信版本不一定在 UA 里写 Tdx，但 window.external 几乎都有
        const isTdx = /Tdx/i.test(navigator.userAgent) || 
                      (window.external && (window.external.Tdx_Call || window.external.Tdx_GetMyName || typeof window.external.SelectStock === 'function'));
        
        if (isTdx || window.TDX_API) {
            const parts = symbolCode.split('.');
            const code = parts[0];
            const suffix = parts[1] || '';
            
            let market = '0'; // 默认深市
            if (suffix === 'SH') market = '1';
            else if (suffix === 'BJ') market = '2';
            
            console.log(`[TdxLink] Attempting to link: ${code} in market ${market}`);

            const fullTdxCode = (market === '1' ? 'SH' : 'SZ') + code;

            // 方式 1: 直接调用通达信外部对象 API
            try {
                if (window.external) {
                    if (window.external.Tdx_Call) {
                        window.external.Tdx_Call("SelectStock", market, code, 1);
                    } else if (typeof window.external.SelectStock === 'function') {
                        window.external.SelectStock(code, market);
                    }
                }
            } catch (e) {
                console.warn('[TdxLink] External API failed', e);
            }

            // 方式 2: stockcode 协议 (多种变体)
            try {
                // 变体 A: 纯代码
                window.location.href = `stockcode:${code}`;
                // 变体 B: 带前缀 (有些版本需要)
                setTimeout(() => { window.location.href = `stockcode:${fullTdxCode}`; }, 50);
            } catch (e) {
                console.warn('[TdxLink] Protocol link failed', e);
            }

            // 方式 3: treeid 协议 (经典 iframe 方式)
            setTimeout(() => {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = `http://www.treeid/code=${code}&market=${market}`;
                document.body.appendChild(iframe);
                setTimeout(() => {
                    if (document.body.contains(iframe)) document.body.removeChild(iframe);
                }, 500);
            }, 150);
        }
    } catch (e) {
        console.error('[TdxLink] Linkage failed:', e);
    }
}
